export default __webpack_public_path__ + "static/media/calendar_overdue.c17c8ca6.svg";